export const LANGUAGE_MOTHER_YES = 'language-mother-yes';
export const LANGUAGE_MOTHER_NO = 'language-mother-no';

export const SCHOOL_TYPE__ELEMENTARY_SCHOOL = 'elementary-school';
export const SCHOOL_TYPE__HIGH_SCHOOL = 'high-school';
export const SCHOOL_TYPE__COLLEGE = 'college';
export const SCHOOL_TYPE__FURTHER_EDUCATION = 'further-education';
export const SCHOOL_TYPE__WORK_PERMISSION = 'work-permission';
export const SCHOOL_TYPE__AUDITOR = 'auditor';
export const SCHOOL_TYPE__APPRAISER = 'appraiser';

export const SEARCH_STATUS__NON_SEARCHING = 'non-searching';
